export const lightTheme = {
  gradient: [
    '#ffffff',
    '#f5f0ff',
    '#e8deff',
    '#f0e4ff',
    '#e8dcff',
    '#ffffff'
  ],
  text: {
    primary: '#333',
    secondary: '#555'
  },
  logo: '#333',
  footer: '#666',
  accents: {
    track: 'linear-gradient(135deg, #8fd3ff 0%, #c6b5ff 45%, #ffb3df 100%)',
    thumb: '#ffffff',
    button: 'linear-gradient(15deg, #8fd3ff 0%, #c6b5ff 45%, #ffb3df 100%)',
    thumbDark: '#121226'
  }
};

export const darkTheme = {
  gradient: [
    '#070920',
    '#090b28',
    '#181b3f',
    '#26244f',
    '#120f2b',
    '#050514'
  ],
  text: {
    primary: '#f8f7ff',
    secondary: '#cbc8ff'
  },
  logo: '#f7f3ff',
  footer: '#aaa7e6',
  accents: {
    track: 'linear-gradient(135deg, #7b68ee 0%, #9370db 45%, #6a5acd 100%)',
    thumb: '#ffffff',
    button: 'linear-gradient(90deg, #9c27b0, #673ab7)',
    thumbDark: '#121226'
  }
};
